var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3234 0.862904C16.5769 1.12426 16.7569 1.4479 16.8454 1.80112C17.0815 3.11005 17.1961 4.43801 17.1877 5.76805C17.1924 7.0782 17.0778 8.38606 16.8454 9.67543C16.7569 10.0287 16.5769 10.3523 16.3234 10.6136C16.0698 10.875 15.7518 11.0648 15.4015 11.164C14.1213 11.5063 9.00081 11.5063 9.00081 11.5063C9.00081 11.5063 3.88027 11.5063 2.60014 11.164C2.2569 11.07 1.94368 10.8892 1.69075 10.6389C1.43782 10.3885 1.25373 10.0772 1.15626 9.73497C0.920159 8.42604 0.805551 7.09808 0.813902 5.76805C0.807379 4.44795 0.92198 3.13004 1.15626 1.83089C1.24467 1.47767 1.42473 1.15403 1.67825 0.892675C1.93177 0.631315 2.24977 0.441486 2.60014 0.342361C3.88027 0 9.00081 0 9.00081 0C9.00081 0 14.1213 0 15.4015 0.312591C15.7518 0.411715 16.0698 0.601544 16.3234 0.862904ZM11.6056 5.76871L7.32612 8.20245V3.33497L11.6056 5.76871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFooter);
export default __webpack_public_path__ + "static/media/youtube-footer.588d341214b95bfaa7afcd05f6b203f2.svg";
export { ForwardRef as ReactComponent };